import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { FocusOnChangeDirective, FeatureService } from '@woolworthsnz/styleguide';
import { ContextResponse, FilterCriteria } from '@woolworthsnz/trader-api';
import { SearchCategoryListComponent } from '../search-category-list/search-category-list.component';
import { SearchQueryParams } from '../models/search-query-params.model';

@Component({
	selector: 'search-results-header',
	template: `
		<div class="headingContainer">
			<h1
				*ngIf="!isBigNightFeatureEnabled"
				class="heading"
				data-cy="categoryHeading"
				tabindex="-1"
				[cdxFocusOnChange]="heading"
			>
				{{ heading }}
			</h1>
			<h1 *ngIf="isBigNightFeatureEnabled" class="heading" data-cy="categoryHeading" tabindex="-1">
				{{ heading }}
			</h1>
			<span *ngIf="!shouldShowNewCategoriesList && totalItems !== undefined" class="productsCount"
				>{{ totalItems }} items</span
			>

			<search-category-list
				*ngIf="shouldShowNewCategoriesList"
				[dasFacets]="dasFacets"
				[dasFacetsRoute]="dasFacetsRoute"
				[dasFacetsQueryParams]="dasFacetsQueryParams"
				[currentShelf]="currentShelf"
			>
			</search-category-list>
		</div>
	`,
	styleUrls: ['./search-results-header.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [NgClass, NgIf, AsyncPipe, FocusOnChangeDirective, SearchCategoryListComponent],
})
export class SearchResultsHeaderComponent {
	@Input() dasFacets: FilterCriteria[] = [];
	@Input() dasFacetsRoute: string[] = [];
	@Input() dasFacetsQueryParams: SearchQueryParams[] = [];
	@HostBinding('attr.new-category-list')
	@Input()
	shouldShowNewCategoriesList = false;
	@Input() totalItems?: number;
	@Input() currentShelf: FilterCriteria;

	private _heading: string;

	constructor(private featureService: FeatureService) {}

	get heading(): string {
		return this._heading;
	}

	@Input()
	set heading(value: string) {
		if (
			this.featureService.isFeatureEnabled(ContextResponse.EnabledFeaturesEnum.GreatToLowPrice) &&
			value &&
			value.toLowerCase() === 'great price'
		) {
			this._heading = 'Low Price';
		} else {
			this._heading = value;
		}
	}

	get isBigNightFeatureEnabled(): boolean {
		return this.featureService.isFeatureEnabled(ContextResponse.EnabledFeaturesEnum.EnableFixForScrollIssue);
	}
}
